// extracted by mini-css-extract-plugin
module.exports = {"categoryGrid":"_74ac13d0","articlesSlider":"_4f2e38ae","quizWrapper":"_e22221a8","quizContainer":"_cdf9c2b6","quizBlock":"_0023a3b5","quizBlockTextWrapper":"_be6d4ff7"};